module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-zh-hans.89dbbfbe080de990f333.svg";